// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

// CSS
import './index.css'

// Assets
import logo from "../../assets/images/logo.png"

// React Router
import { Link } from 'react-router';


function NavigationBar() {
  return (
    <>
      <Navbar className='navigationBar' bg="dark" data-bs-theme="dark" expand="lg">
        <Container fluid>
          <Link to="/" className='navigationBarLink' style={{paddingRight: '30px', fontSize: "1.25rem"}}>
            <img className='p-1' src={logo} height={65} width="auto" />
          </Link>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="p-2">
            <Link className='navigationBarLink' to="/portfolios">Portfolio Examples</Link>
          </Nav>
          <Nav className="p-2">
            <Link className='navigationBarLink' to="/quiz">AI Portfolio Builder</Link>
          </Nav>
          <Nav className="p-2">
            <Link className='navigationBarLink' to="/learn">Learn</Link>
          </Nav>
          <Nav className="p-2">
            <Link className='navigationBarLink' to="/stock-market-glossary">Glossary</Link>
          </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavigationBar;